import {
  getQuoteTypeNameListRequest,
} from '@/assets/request/QuoteRequest.js'
import { Message } from 'element-ui';
/**
 * 配件品质的后端定义数据的存储
 */
export default {
  namespaced: true,
  state: {
    partList: [], /** 品质后端返回的数据, key分别为code和text */
  },
  mutations: {
    updatePartMutation(state, {
      listData,
    }) {
      state.partList = listData;
    },
  },
  actions: {
    updatePartAction({ commit }, { ins_id, }) {
      getQuoteTypeNameListRequest({
        ins_id,
      }).then((result) => {
        const { data: res, } = result;
        const isSuccess = Number(res.code) === 200;
        if (!isSuccess) return Message.warning(res.msg || '品质查询失败，请重试！');
        /** 现在后端规定传数组肯定是空，所以如果返回的是数组，不需要做任何更改 */
        if (toString.call(res.data) === '[object Array]') return;
        if (toString.call(res.data) !== '[object Object]') return Message.warning('服务器返回数据格式错误，请重试！');
        commit('updatePartMutation', {
          listData: Object.entries(res.data).map(item => ({
            code: item[0],
            text: item[1],
          })),
        });
      })
    },
  },
  getters: {
    allGetter: state => state,
  },
}
